export const TX111_TREATMENT_KEY = 'tx-111';
export const TX111_GROUP_PARAMETER_KEY = 'group';
export let TX111_GROUP_PARAMETER_OPTIONS;

(function (TX111_GROUP_PARAMETER_OPTIONS) {
  TX111_GROUP_PARAMETER_OPTIONS["control"] = "control";
  TX111_GROUP_PARAMETER_OPTIONS["variant_B"] = "extend";
  TX111_GROUP_PARAMETER_OPTIONS["variant_C"] = "30days";
})(TX111_GROUP_PARAMETER_OPTIONS || (TX111_GROUP_PARAMETER_OPTIONS = {}));